import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { Router, ActivatedRoute } from "@angular/router";
import { DomainModel, DomainService, DomainPostRequest, UserService} from "@bt/core";
import { NotifierService } from "angular-notifier";
import {faPlus, faTrashAlt, faPencilAlt, faCheck, faOtter} from '@fortawesome/free-solid-svg-icons';

import { NgbModal,NgbActiveModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { DeleteUserModalContent } from '@bt/admin/all-users/delete-users-modal';
import { forEach } from '@angular/router/src/utils/collection';


import { environment } from "@bt/environments";
const apiUrl = environment.apiUrl;

@Component({
  selector: 'app-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.scss']
})
export class DomainsComponent extends BaseComponent implements OnInit {


  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faPencilAlt = faPencilAlt;
  faCheck = faCheck;

  public isResponsed: boolean = false;
  public hasInfo:boolean = false;

  public isSmthChecked: boolean;

  //domains: DomainModel[];
  domainModel: DomainModel;
  codeForDomain: DomainModel;

  domains = new Array<DomainPostRequest>();

  notifier: any;

  public modalRef: NgbModalRef;

  constructor(
    private router: Router,
    private domainService: DomainService,
    notifierService: NotifierService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private userService: UserService,
    ) {
    super();
    this.notifier = notifierService;


  }

  ngOnInit() {
    this.codeForDomain = new DomainModel();
    this.GetDomains();
  }

  public getRole():number {
		return this.userService.getRole();
  }

  public goEditDomain(id:number){
    if(!!id) this.router.navigateByUrl('app/editdomain/' + id);
     else this.router.navigateByUrl('app/newdomain');

  }

  monetizationOutput(oneDomain: DomainModel){
     return oneDomain.monetization == 0 ? "Отсутствует" :
     oneDomain.monetization == 1 ? "Только новостная" :
     oneDomain.monetization == 2 ? "Полная" : "none";
  }

  GetDomains(){
    this.setLoading(true);
    this.domainService.GetDomains()
    .then((resp) => {
      this.domains = resp.data;
      this.hasInfo = resp.data.length != 0;
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка доменов");
      this.hasInfo = false;
      this.isResponsed = true;
      this.setLoading(false);
    });
  }

  public isChecked()
  {
    this.isSmthChecked = false;
    this.domains.forEach(temp => {
      if (temp.deleted == true)
      {
        this.isSmthChecked = true;
      }
    });
    return this.isSmthChecked;
  }

  public openDeleteDomains(){
    let t=this;
    t.modalRef = t.modalService.open(DeleteUserModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true ,
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',

      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.title = "Удаление";
      t.modalRef.componentInstance.description="Вы действительно хотите удалить отмеченное?";
      t.modalRef.componentInstance.button = "Удалить";
      t.modalRef
      .result.then((result)=>{
        if(result){

          var domainTodelete = [];
          for(var i=0; i<t.domains.length;i++){
            if(t.domains[i].deleted){
              domainTodelete.push(t.domains[i]);
            }
          }

          t.domainService.deleteDomain(domainTodelete)
          .then((resp) => {
            if (resp.data == true) {
              t.notifier.notify('success', "Успешно удалено");
              t.GetDomains();
            }
          })
          .catch((error) => {
        //console.error(error.error);
          });
        }


      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

  public getCodeForDomain(domain: DomainModel)
  {
    this.codeForDomain = domain;
    // this.codeForDomain.code = '<script>function ready(){function e(e){e.pushManager.getSubscription().then(function(t){null===t&&e.pushManager.subscribe({userVisibleOnly:!0,applicationServerKey:"VAPID:publicKey"}).then(function(e){var t={endpoint:e.endpoint,p256dh:n(e.getKey("p256dh")),auth:n(e.getKey("auth"))},i=new XMLHttpRequest;i.open("POST","https://learn.blockchaincapital.pro:444/api/pushpub/reg"),i.setRequestHeader("Content-Type","application/json"),i.send(JSON.stringify(t))}).catch(function(e){console.error("Unable to subscribe to push",e)})})}function n(e){for(var n="",t=new Uint8Array(e),i=t.byteLength,r=0;r<i;r++)n+=String.fromCharCode(t[r]);return window.btoa(n)}"serviceWorker"in navigator?window.addEventListener("load",()=>{navigator.serviceWorker.register("/ServiceWorker.js").then(n=>{"granted"===Notification.permission?e(n):function(n){Notification.requestPermission(function(t){"granted"==t&&e(n)})}(n)})}):$("#NoSupport").show()}document.addEventListener("DOMContentLoaded",ready);</script>'.replace("VAPID:publicKey",this.codeForDomain.publicKey);
  }

  public downloadFile(){
    var element = document.createElement('a');
    element.setAttribute('href', "data:text/plain;charset=utf-8,importScripts('" + encodeURIComponent(apiUrl+"push/ServiceWorker.js")+"');");
    element.setAttribute('download', "my-push-worker-fb.js");
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);


    var elm = document.getElementById("divClipboard");
    // for Internet Explorer

    if((<any>document).body.createTextRange) {
      var range = (<any>document).body.createTextRange();
      range.moveToElementText(elm);
      range.select();
      document.execCommand("Copy");
    }
    else if(window.getSelection) {
      // other browsers

      var selection = window.getSelection();
      var range2 = document.createRange();
      range2.selectNodeContents(elm);
      selection.removeAllRanges();
      selection.addRange(range2);
      document.execCommand("Copy");
    }
  }

  typeOutput(DomainModel){
    var output = "";
    DomainModel.type == 0 ?  output = ("Без эффектов") :
    DomainModel.type == 1 ?  output = ("Загрузка через " +DomainModel.n+ " сек.") :
    DomainModel.type == 2 ?  output = ("Вызов через функцию JavaScript") : output = ("please fix me ☺");
    return output;
  }

}



// WEBPACK FOOTER //
// ./src/app/domains/domains.component.ts